import React from 'react';
import ReactPlayer from 'react-player/lazy';
import { IconDownload2, IconMicrophone } from '@alvogen/shared/components/assets';

import { IEmbed, ILink } from 'utils/types';
import { Link } from 'components/link/Link';

import s from './Event.module.scss';

type Props = {
  presentation?: ILink;
  startDateTime?: string;
  endDateTime?: string;
  startDate?: string;
  endDate?: string;
  letter?: ILink;
  webcast?: ILink;
  address?: React.ReactNode;
  booth?: string;
  video?: IEmbed;
  children?: React.ReactNode;
};

export const Event = ({
  presentation,
  startDateTime,
  endDateTime,
  startDate,
  endDate,
  letter,
  webcast,
  address,
  booth,
  video,
  children,
}: Props) => {
  // Get larger thumbnails for lazyloading
  const largeThumbnail = () => {
    if (video && video.providerName === 'Vimeo') {
      return video.thumbnailUrl.replace('_295x166', '_1280x720');
    } else if (video && video.providerName === 'YouTube') {
      return video.thumbnailUrl.replace('hqdefault', 'maxresdefault');
    } else {
      return true;
    }
  };

  return (
    <div className={s.event}>
      <div className={s.event__container}>
        <div className={s.event__layout}>
          <div className={s.event__side}>
            <dl className={s.event__list}>
              {presentation && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Investor Presentation</dt>
                  <dd className={s.event__text}>
                    <Link {...presentation}>
                      <a className={s.event__link}>
                        <IconDownload2 /> Download PDF
                      </a>
                    </Link>
                  </dd>
                </div>
              )}
              {letter && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Investor Presentation</dt>
                  <dd className={s.event__text}>
                    <Link {...letter}>
                      <a className={s.event__link}>
                        <IconDownload2 /> Download PDF
                      </a>
                    </Link>
                  </dd>
                </div>
              )}
              {webcast && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Webcast</dt>
                  <dd className={s.event__text}>
                    <Link {...webcast}>
                      <a className={s.event__link}>
                        <IconMicrophone /> Listen
                      </a>
                    </Link>
                  </dd>
                </div>
              )}
              {startDate && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Date</dt>
                  <dd className={s.event__text}>
                    <time dateTime={startDateTime} className={s.event__time}>
                      {startDate}
                    </time>

                    {endDate && endDate !== startDate && (
                      <>
                        {' '}
                        —{' '}
                        <time dateTime={endDateTime} className={s.event__time}>
                          {endDate}
                        </time>
                      </>
                    )}
                  </dd>
                </div>
              )}
              {address && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Location</dt>
                  <dd className={s.event__text}>{address}</dd>
                </div>
              )}
              {booth && (
                <div className={s.event__item}>
                  <dt className={s.event__label}>Booth</dt>
                  <dd className={s.event__text}>{booth}</dd>
                </div>
              )}
            </dl>
          </div>
          {video?.embedUrl && (
            <div className={s.event__video}>
              <div className={s.event__videoFrame}>
                <ReactPlayer
                  light={largeThumbnail()}
                  url={video.embedUrl}
                  width={1120}
                  height={630}
                  playsinline
                  controls
                  volume={null}
                  muted={false}
                />
              </div>
            </div>
          )}
          <div className={s.event__main}>{children}</div>
        </div>
      </div>
    </div>
  );
};
